import React, { memo, useCallback, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BottomNavBar.css";
import { googleLogout } from "@react-oauth/google";
import { getUserRole, getUserPlanta } from "../../../utils/authStorage";
import { useDemo } from "@app/providers/DemoContext"; // Importar el contexto de demo

const BottomNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDemoMode } = useDemo(); // Usar el contexto de demo

  // Funci�n principal de navegaci�n para TODOS los enlaces
  const navigateTo = useCallback(
    (path) => {
      console.log("Navegando a:", path); // Debug
      navigate(path);
    },
    [navigate],
  );

  const getRoleFromToken = () => getUserRole();

  const getPlantaFromToken = () => getUserPlanta();

  const getRole = () => {
    const tokenRole = getRoleFromToken();
    if (tokenRole === 5) {
      const rolDevelop = sessionStorage.getItem("RolDevelop");
      return rolDevelop ? parseInt(rolDevelop) : 5;
    }
    // Si el rol es 4 (default) y estamos en modo demo, mostrar como supervisor (rol 3)
    if (tokenRole === 4 && isDemoMode) {
      return 3;
    }
    return tokenRole;
  };

  const handleHomeClick = () => {
    const idrol = getRole();
    if (idrol === 1) {
      navigateTo("/homeadmin");
    } else if (idrol === 2) {
      navigateTo("/homeinspector");
    } else if (idrol === 3) {
      navigateTo("/homesupervisor");
    } else if (idrol === 7) {
      navigateTo("/homerh");
    } else {
      navigateTo("/welcome");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    sessionStorage.removeItem("refreshToken");
    localStorage.removeItem("userName");
    sessionStorage.removeItem("userName");
    localStorage.removeItem("userId");
    sessionStorage.removeItem("userId");
    localStorage.removeItem("userRole");
    sessionStorage.removeItem("userRole");
    localStorage.removeItem("imageProfile");
    sessionStorage.removeItem("imageProfile");
    localStorage.removeItem("googleAauth");
    sessionStorage.removeItem("googleAauth");
    // Tambi�n limpiar variables de desarrollo
    sessionStorage.removeItem("RolDevelop");
    sessionStorage.removeItem("PlantaDevelop");
    googleLogout();
    navigateTo("/");
  };

  const isActive = (path) => (location.pathname === path ? "active" : "");

  const isAdminHomePath = () => {
    const adminPaths = [
      "/homeadmin",
      "/homeadmin/herramientas",
      "/homeadmin/usuarios",
      "/homeadmin/inventario",
      "/homeadmin/equipoproteccion",
      "/homeadmin/plantas",
      "/homeadmin/empresas",
    ];
    return adminPaths.includes(location.pathname) ? "active" : "";
  };

  const isRHHomePath = () => {
    const rhPaths = ["/homerh", "/homerh/inventario"];
    return rhPaths.includes(location.pathname) ? "active" : "";
  };

  // COMPONENTE CustomNavLink MEJORADO
  const CustomNavLink = memo(({ to, icon, label, usePattern = false }) => {
    const isActive = usePattern
      ? location.pathname.startsWith(to)
      : location.pathname === to;

    return (
      <div
        role="button"
        tabIndex={0}
        className={`nav-item ${isActive ? "active" : ""}`}
        onClick={() => navigateTo(to)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            (() => navigateTo(to))(e);
          }
        }}
        style={{ cursor: "pointer" }}
        data-path={to}
      >
        <i className={icon}></i>
        <span>{label}</span>
      </div>
    );
  });

  const isDeveloper = getRoleFromToken() === 5;
  const menuRole = getRole();

  // Planos: dev siempre, admin/inspector siempre, supervisor solo planta 5
  const showPlanosOption =
    isDeveloper ||
    [1, 2].includes(menuRole) ||
    (menuRole === 3 && getPlantaFromToken() === 5);

  // Estado para el men� "Más"
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);
  const moreMenuRef = useRef(null);

  // Cerrar men� "Más" al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (moreMenuRef.current && !moreMenuRef.current.contains(e.target)) {
        setMoreMenuOpen(false);
      }
    };
    if (moreMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside, {
        passive: true,
      });
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [moreMenuOpen]);

  // Cerrar men� "Más" al navegar
  const navigateAndCloseMore = useCallback(
    (path) => {
      setMoreMenuOpen(false);
      navigateTo(path);
    },
    [navigateTo],
  );

  // Definir items de navegaci�n por rol
  const MAX_VISIBLE = 5;

  const getNavItems = () => {
    switch (menuRole) {
      case 1: // Admin
        return [
          {
            to: null,
            icon: "fa-solid fa-house",
            label: "Home",
            onClick: handleHomeClick,
            isActiveFn: isAdminHomePath,
          },
          {
            to: "/formatos",
            icon: "fa-solid fa-file-signature",
            label: "Formatos",
            usePattern: true,
          },
          {
            to: "/reportes",
            icon: "fa-solid fa-list-check",
            label: "Reportes",
            usePattern: true,
          },
          {
            to: "/admin/plan-anual",
            icon: "fas fa-calendar-check",
            label: "Plan Anual",
            usePattern: true,
          },
          {
            to: "/pendientes",
            icon: "fa-solid fa-calendar-xmark",
            label: "Pendientes",
          },
          ...(showPlanosOption
            ? [
                {
                  to: "/planos-interactivos",
                  icon: "fas fa-map-marked-alt",
                  label: "Planos",
                  usePattern: true,
                },
              ]
            : []),
          {
            to: "/ai-agent",
            icon: "fa-solid fa-robot",
            label: "DARPHA IA",
            usePattern: true,
          },
          ...(!isDemoMode
            ? [
                {
                  to: "/calendario-social",
                  icon: "fa-solid fa-calendar-days",
                  label: "Calendario",
                  usePattern: true,
                },
              ]
            : []),
          { to: "/profile", icon: "fa-solid fa-user", label: "Perfil" },
        ];
      case 2: // Inspector
        return [
          {
            to: null,
            icon: "fa-solid fa-house",
            label: "Home",
            onClick: handleHomeClick,
            isActiveFn: () => isActive("/homeinspector"),
          },
          {
            to: "/inspector/reports",
            icon: "fa-solid fa-clipboard-check",
            label: "Mis Reportes",
            usePattern: true,
          },
          {
            to: "/mantenimiento",
            icon: "fa-solid fa-plus-square",
            label: "Nuevo Reporte",
            usePattern: true,
          },
          {
            to: "/formatos",
            icon: "fa-solid fa-file-signature",
            label: "Formatos",
            usePattern: true,
          },
          {
            to: "/inspector/plan-anual",
            icon: "fas fa-calendar-check",
            label: "Plan Anual",
            usePattern: true,
          },
          {
            to: "/pendientes",
            icon: "fa-solid fa-check-to-slot",
            label: "Pendientes",
          },
          {
            to: "/inspector/inventory",
            icon: "fas fa-boxes",
            label: "Inventario",
            usePattern: true,
          },
          {
            to: "/inspector/equipment",
            icon: "fas fa-fire-extinguisher",
            label: "Equipo PCI",
            usePattern: true,
          },
          {
            to: "/scanner/take",
            icon: "fas fa-qrcode",
            label: "Salida QR",
            usePattern: true,
          },
          {
            to: "/herramientas",
            icon: "fas fa-tools",
            label: "Préstamo",
            usePattern: true,
          },
          ...(showPlanosOption
            ? [
                {
                  to: "/planos-interactivos",
                  icon: "fas fa-map-marked-alt",
                  label: "Planos",
                  usePattern: true,
                },
              ]
            : []),
          {
            to: "/ai-agent",
            icon: "fa-solid fa-robot",
            label: "DARPHA IA",
            usePattern: true,
          },
          {
            to: "/inspector/certificaciones",
            icon: "fas fa-medal",
            label: "Certificaciones",
            usePattern: true,
          },
          ...(!isDemoMode
            ? [
                {
                  to: "/calendario-social",
                  icon: "fa-solid fa-calendar-days",
                  label: "Calendario",
                  usePattern: true,
                },
              ]
            : []),
          { to: "/profile", icon: "fa-solid fa-user", label: "Perfil" },
        ];
      case 3: // Supervisor
        return [
          {
            to: "/homesupervisor",
            icon: "fas fa-chart-bar",
            label: "Dashboard",
          },
          {
            to: "/supervisor/plan-anual",
            icon: "fas fa-calendar-check",
            label: "Plan Anual",
            usePattern: true,
          },
          {
            to: "/monitor",
            icon: "fa-solid fa-calendar-xmark",
            label: "Pendientes",
            usePattern: true,
          },
          {
            to: "/reportes",
            icon: "fa-solid fa-file-signature",
            label: "Reportes",
          },
          ...(showPlanosOption
            ? [
                {
                  to: "/planos-interactivos",
                  icon: "fas fa-map-marked-alt",
                  label: "Planos",
                  usePattern: true,
                },
              ]
            : []),
          {
            to: "/supervisor/certificaciones",
            icon: "fas fa-medal",
            label: "Certificaciones",
            usePattern: true,
          },
          { to: "/alarmcontrol", icon: "fas fa-phone", label: "Emergencia" },
          { to: "/profile", icon: "fa-solid fa-user", label: "Perfil" },
        ];
      case 7: // RH
        return [
          {
            to: null,
            icon: "fa-solid fa-house",
            label: "Home",
            onClick: handleHomeClick,
            isActiveFn: isRHHomePath,
          },
          {
            to: "/rh/plan-anual",
            icon: "fas fa-calendar-check",
            label: "Plan Anual",
            usePattern: true,
          },
          {
            to: "/reportes",
            icon: "fa-solid fa-file-signature",
            label: "Reportes",
            usePattern: true,
          },
          {
            to: "/formatos",
            icon: "fa-solid fa-file-alt",
            label: "Formatos",
            usePattern: true,
          },
          {
            to: "/pendientes",
            icon: "fa-solid fa-calendar-xmark",
            label: "Pendientes",
          },
          {
            to: "/ai-agent",
            icon: "fa-solid fa-robot",
            label: "DARPHA IA",
            usePattern: true,
          },
          ...(!isDemoMode
            ? [
                {
                  to: "/calendario-social",
                  icon: "fa-solid fa-calendar-days",
                  label: "Calendario",
                  usePattern: true,
                },
              ]
            : []),
          { to: "/profile", icon: "fa-solid fa-user", label: "Perfil" },
        ];
      case 5: // Developer (rol directo, sin simular)
        return [
          {
            to: null,
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            onClick: () => {
              sessionStorage.removeItem("RolDevelop");
              sessionStorage.removeItem("PlantaDevelop");
              navigateTo("/homedeveloper");
            },
            isActiveFn: () =>
              location.pathname === "/homedeveloper" ? "active" : "",
          },
          {
            to: "/security-dashboard",
            icon: "fas fa-shield-alt",
            label: "Seguridad",
            usePattern: true,
          },
          {
            to: "/sessions-management",
            icon: "fas fa-user-clock",
            label: "Sesiones",
            usePattern: true,
          },
          {
            to: "/homedeveloper/tickets",
            icon: "fab fa-trello",
            label: "Tickets",
            usePattern: true,
          },
          {
            to: "/developer-dashboard",
            icon: "fas fa-bug",
            label: "Errores",
          },
          {
            to: "/catalogos",
            icon: "fas fa-book",
            label: "Catálogos",
            usePattern: true,
          },
          {
            to: "/ai-agent",
            icon: "fa-solid fa-robot",
            label: "DARPHA IA",
            usePattern: true,
          },
          {
            to: "/planos-interactivos",
            icon: "fas fa-map-marked-alt",
            label: "Planos",
            usePattern: true,
          },
          { to: "/profile", icon: "fas fa-user", label: "Perfil" },
        ];
      default:
        return [
          {
            to: null,
            icon: "fa-solid fa-right-from-bracket",
            label: "Logout",
            onClick: handleLogout,
          },
        ];
    }
  };

  const allItems = getNavItems();
  const needsMore = allItems.length > MAX_VISIBLE;
  const visibleItems = needsMore
    ? allItems.slice(0, MAX_VISIBLE - 1)
    : allItems;
  const moreItems = needsMore ? allItems.slice(MAX_VISIBLE - 1) : [];

  // Verificar si alguna ruta del men� "Más" est� activa
  const isMoreMenuActive = useCallback(() => {
    return moreItems.some((item) => {
      if (!item.to) return false;
      return item.usePattern
        ? location.pathname.startsWith(item.to)
        : location.pathname === item.to;
    });
  }, [moreItems, location.pathname]);

  // Renderizar un item de navegaci�n
  const renderNavItem = (item, index, fromMoreMenu = false) => {
    const itemIsActive = item.isActiveFn
      ? item.isActiveFn()
      : item.to
        ? item.usePattern
          ? location.pathname.startsWith(item.to)
            ? "active"
            : ""
          : location.pathname === item.to
            ? "active"
            : ""
        : "";

    if (fromMoreMenu) {
      return (
        <div
          role="button"
          tabIndex={0}
          key={item.to || item.label}
          className={`more-menu-item ${itemIsActive ? "active" : ""}`}
          onClick={() => {
            if (item.onClick) {
              setMoreMenuOpen(false);
              item.onClick();
            } else {
              navigateAndCloseMore(item.to);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") e.currentTarget.click();
          }}
        >
          <i className={item.icon}></i>
          <span>{item.label}</span>
        </div>
      );
    }

    return (
      <div
        role="button"
        tabIndex={0}
        key={item.to || item.label}
        className={`nav-item ${item.className || ""} ${itemIsActive ? "active" : ""}`}
        onClick={() => (item.onClick ? item.onClick() : navigateTo(item.to))}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            (() => (item.onClick ? item.onClick() : navigateTo(item.to)))(e);
          }
        }}
        style={{ cursor: "pointer" }}
      >
        <i className={item.icon}></i>
        <span>{item.label}</span>
      </div>
    );
  };

  return (
    <div className="bottom-nav">
      {visibleItems.map((item, i) => renderNavItem(item, i))}

      {needsMore && (
        <div className="nav-item-more-wrapper" ref={moreMenuRef}>
          <div
            role="button"
            tabIndex={0}
            className={`nav-item ${isMoreMenuActive() || moreMenuOpen ? "active" : ""}`}
            onClick={() => setMoreMenuOpen((prev) => !prev)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                (() => setMoreMenuOpen((prev) => !prev))(e);
              }
            }}
          >
            <i
              className={`fas ${moreMenuOpen ? "fa-times" : "fa-ellipsis-h"}`}
            ></i>
            <span>Más</span>
          </div>
          {moreMenuOpen && (
            <div className="more-menu-popup">
              {moreItems.map((item, i) => renderNavItem(item, i, true))}
            </div>
          )}
        </div>
      )}

      {/* Opción para cambiar rol (solo visible para desarrolladores) */}
      {isDeveloper && (
        <div
          role="button"
          tabIndex={0}
          className="nav-item"
          onClick={() => {
            sessionStorage.removeItem("RolDevelop");
            sessionStorage.removeItem("PlantaDevelop");
            navigateTo("/homedeveloper/roles");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              sessionStorage.removeItem("RolDevelop");
              sessionStorage.removeItem("PlantaDevelop");
              navigateTo("/homedeveloper/roles");
            }
          }}
        >
          <i className="fas fa-exchange-alt"></i>
          <span>Cambiar Rol</span>
        </div>
      )}
    </div>
  );
};

export default memo(BottomNavBar);
